import React from 'react';
import {Button} from '@components';
import {Card, Form, Row, Col, ButtonGroup} from 'react-bootstrap';
import {Formik} from 'formik';
import * as yup from 'yup';
import {useLocation, useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {Get, Put} from '@app/utils/httpProvider';
import {useQuery, useQueryClient, useMutation} from 'react-query';
import Editor from '@app/components/editor/Editor';
import 'react-tabs/style/react-tabs.css';
import {
    messageError,
    messageToast,
    status200,
    role,
    objectLoaiNoiDung,
    styleSelectError,
    styleSelectDefault
} from '../../utils/define';
import {BaseGatewayImage, DEPARTMENT_API} from '../../utils/apiUrl.js';
import {getInfomationAccountFromToken, isValidUrl} from '../../utils/helper';
import DatePicker from 'react-datepicker';
import loginHistory from '@app/store/reducers/loginHistory';
import {NIL as NIL_UUID} from 'uuid';
import Select from 'react-select';
import {AsyncPaginate} from 'react-select-async-paginate';
import {apiRoleMappingPagingAction} from '@app/store/reducers/apiRoleMapping';
import {useDispatch} from 'react-redux';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';

const schema = yup.object().shape({
    departmentCode: yup.string().required(messageError.emptyMessage)
});

const DepartmentEdit = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const location = useLocation();
    const paramUrl = new URLSearchParams(location.search.substring(1));
    const itemId = paramUrl.get('id');

    // const inforAccount = getInfomationAccountFromToken();
    // let accountRoleManageDevice = false;

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role.split(', ');
    //     accountRoleManageDevice =
    //         userRole.includes(role.Admin) || userRole.includes(role.Editor);
    //     // accountRoleBooker =
    //     //     userRole.includes(role.Admin) || userRole.includes(role.Booker);
    // }

    const itemEdit = useQuery([itemId], () =>
        Get(DEPARTMENT_API.GET_ITEM, itemId)
    );

    const editFunc = useMutation((value) =>
        Put(DEPARTMENT_API.UPDATE_ITEM, itemId, value)
    );

    const handleEdit = async (values) => {
        const model = {...values};

        model.id = itemId;

        editFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    // dispatch(
                    //     apiRoleMappingPagingAction({
                    //         PageIndex: 1,
                    //         PageSize: 10000
                    //     })
                    // );
                    queryClient.setQueryData(itemId, model);
                    history.goBack();
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    const isLoading = itemEdit.isLoading ? true : false;
    const isError = itemEdit.isError ? true : false;
    const error = itemEdit.isError ? itemEdit.error : null;

    return (
        <Card>
            <Card.Header as="h5">Xem hoặc sửa đơn vị</Card.Header>
            <Card.Body>
                {isLoading ? (
                    <div>Đang tải...</div>
                ) : isError ? (
                    <div>Có lỗi xảy ra: ${error.message}</div>
                ) : itemEdit.data == null ? (
                    <div>Danh mục không tồn tại</div>
                ) : (
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(values) => handleEdit(values)}
                        initialValues={{
                            departmentCode:
                                itemEdit.data && itemEdit.data.departmentCode
                                    ? itemEdit.data.departmentCode
                                    : '',
                            departmentName:
                                itemEdit.data && itemEdit.data.departmentName
                                    ? itemEdit.data.departmentName
                                    : ''
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            errors,
                            touched,
                            setFieldValue
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <HorizontalFieldsRow
                                    fields={[
                                        {
                                            label: 'Code đơn vị',
                                            name: 'departmentCode',
                                            value: values.departmentCode,
                                            onChange: handleChange,
                                            isInvalid:
                                                errors.departmentCode &&
                                                touched.departmentCode,
                                            error: touched.departmentCode
                                                ? errors.departmentCode
                                                : null
                                        },
                                        {
                                            label: 'Tên đơn vị',
                                            name: 'departmentName',
                                            value: values.departmentName,
                                            onChange: handleChange,
                                            isInvalid:
                                                errors.departmentName &&
                                                touched.departmentName,
                                            error: touched.departmentName
                                                ? errors.departmentName
                                                : null
                                        }
                                    ]}
                                />
                                <Form.Group as={Row} className="mb-3">
                                    <Col md={{span: 10, offset: 2}}>
                                        <ButtonGroup className="mb-2">
                                            <Button
                                                type="submit"
                                                theme="primary"
                                            >
                                                Sửa
                                            </Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button
                                                onClick={() => history.goBack()}
                                                theme="secondary"
                                            >
                                                Hủy
                                            </Button>
                                        </ButtonGroup>
                                    </Col>
                                </Form.Group>
                            </Form>
                        )}
                    </Formik>
                )}
            </Card.Body>
        </Card>
    );
};

export default DepartmentEdit;
